import { css } from '@emotion/css'
import { fontWeight, colors, spacing, getThemeColors, mediaQueryHelper, breakpoint } from '@offerzen/pinata-shame'

const styles = {
  item: css({
    display: 'flex',
    alignItems: 'baseline',
    flexDirection: 'column',
    gap: spacing.small,
    marginBottom: spacing.medium,

    ':last-child': {
      marginBottom: 0,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginBottom: spacing.default,
      flexDirection: 'row',
      gap: 0,
    },
  }),

  term: css({
    flex: '0 0 auto',
    fontWeight: fontWeight.semiBold,
    color: colors.oxfordBlue,

    '::after': {
      content: '""',
      paddingRight: spacing.small,
    },
  }),

  details: css({
    margin: 0,
    color: colors.scorpion,
    display: 'flex',
    gap: spacing.small,
    flexDirection: 'column',

    [mediaQueryHelper(breakpoint.tablet)]: {
      alignItems: 'center',
      flexDirection: 'row',
    },

    ul: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexWrap: 'wrap',
      rowGap: spacing.small,

      'li::after': {
        content: '""',
        paddingRight: spacing.small,
      },
    },
  }),
}

export default styles
